export default "__VITE_ASSET__BKH_OcDx__"